import React, { useEffect, useState } from 'react';
import $ from 'jquery';

import {
    getApiBookmarkUrl,
    getBookmarkUrl,
    getPageUrlFromSlug,
    getFolderUrl,
    getDocumentUrl,
    getCategoryUrl, getQuestionUrl,
} from '../../utilities/urlHelper';

import { BOOKMARKABLE_TYPE, ICON } from '../../utilities/CONSTANTS';

import HiddenForm from '../HiddenForm';

const BookmarkDropdown = ({ bookmarkId }) => (
    <div className="dropdown dropdown-right-aligned flex-none">
        <button className="left-nav__menu dropdown-link" type="button">
            <img className="button-icon" height="16" width="4" src="/img/icons/dropdown-elipsis.svg" alt="dropdown menu" />
        </button>
        <div className="dropdown-overlay" style={{ display: 'none' }} />
        <div className="dropdown-content no-select" style={{ display: 'none' }}>
            <HiddenForm method="delete" url={`${getBookmarkUrl(window.userId)}/${bookmarkId}`} value="Remove bookmark" />
            <a className="dropdown-option do-cancel">Cancel</a>
        </div>
    </div>
);

const PageBookmark = ({ bookmark: { id, bookmarkable } }) => (
    <li className="left-nav__item left-nav__bookmark">
        <img className="left-nav__page-icon" height="18" width="18" src="/img/icons/file-icon-page.png" alt="" />
        <a href={getPageUrlFromSlug(bookmarkable.slug)} className="left-nav__text">{bookmarkable.title}</a>
        <BookmarkDropdown bookmarkId={id} />
    </li>
);

const DocumentBookmark = ({ bookmark: { id, bookmarkable } }) => (
    <li className="left-nav__item left-nav__bookmark">
        <img className="left-nav__page-icon" height="18" width="18" src="/img/icons/file-icon-document.png" alt="" />
        <a href={getDocumentUrl(bookmarkable.id)} className="left-nav__text">{bookmarkable.title}</a>
        <BookmarkDropdown bookmarkId={id} />
    </li>
);

const FolderBookmark = ({ bookmark: { id, bookmarkable } }) => (
    <li className="left-nav__item left-nav__bookmark">
        <img className="left-nav__icon rounded" height="22" width="22" src={bookmarkable.icon} style={{ backgroundColor: `#${bookmarkable.color}` }} alt="" />
        <a href={getFolderUrl(bookmarkable.category_id, bookmarkable.id)} className="left-nav__text">{bookmarkable.name}</a>
        <BookmarkDropdown bookmarkId={id} />
    </li>
);

const CategoryBookmark = ({ bookmark: { id, bookmarkable } }) => (
    <li className="left-nav__item left-nav__bookmark">
        <img className="left-nav__icon rounded" height="22" width="22" src={bookmarkable.icon} style={{ backgroundColor: `#${bookmarkable.color}` }} alt="" />
        <a href={getCategoryUrl(bookmarkable.id)} className="left-nav__text">{bookmarkable.name}</a>
        <BookmarkDropdown bookmarkId={id} />
    </li>
);

const ExternalResourceBookmark = ({ bookmark: { id, bookmarkable } }) => (
    <li className="left-nav__item left-nav__bookmark">
        <img className="left-nav__page-icon" height="18" width="18" src={bookmarkable.icon_url} alt="" />
        <a className="left-nav__text" href={bookmarkable.url} target="_blank" rel="noreferrer">{bookmarkable.title}</a>
        <BookmarkDropdown bookmarkId={id} />
    </li>
);

const QuestionBookmark = ({ bookmark: { id, bookmarkable } }) => (
    <li className="left-nav__item left-nav__bookmark">
        <img className="left-nav__page-icon" height="18" width="18" src={ICON.QUESTION} alt="" />
        <a href={getQuestionUrl(bookmarkable.id)} className="left-nav__text">{bookmarkable.title}</a>
        <BookmarkDropdown bookmarkId={id} />
    </li>
);

const DeletedBookmark = ({ bookmark: { id } }) => (
    <li className="left-nav__item left-nav__bookmark">
        <img className="left-nav__page-icon" height="18" width="18" src="/img/icons/file-icon-page-archived.png" alt="" />
        <span className="left-nav__text">Item deleted</span>
        <BookmarkDropdown bookmarkId={id} />
    </li>
);

const LostAccessBookmark = ({ bookmark: { id } }) => (
    <li className="left-nav__item left-nav__bookmark">
        <img className="left-nav__page-icon" height="18" width="18" src="/img/icons/file-icon-page-archived.png" alt="" />
        <span className="left-nav__text">Lost access to item</span>
        <BookmarkDropdown bookmarkId={id} />
    </li>
);

const Bookmark = ({ bookmark }) => {
    if (bookmark.bookmarkable && bookmark.bookmarkable_type === BOOKMARKABLE_TYPE.PAGE) {
        return <PageBookmark key={bookmark.id} bookmark={bookmark} />;
    } if (bookmark.bookmarkable && bookmark.bookmarkable_type === BOOKMARKABLE_TYPE.FOLDER) {
        return <FolderBookmark key={bookmark.id} bookmark={bookmark} />;
    } if (bookmark.bookmarkable && bookmark.bookmarkable_type === BOOKMARKABLE_TYPE.CATEGORY) {
        return <CategoryBookmark key={bookmark.id} bookmark={bookmark} />;
    } if (bookmark.bookmarkable && bookmark.bookmarkable_type === BOOKMARKABLE_TYPE.EXTERNAL_RESOURCE) {
        return <ExternalResourceBookmark key={bookmark.id} bookmark={bookmark} />;
    } if (bookmark.bookmarkable && bookmark.bookmarkable_type === BOOKMARKABLE_TYPE.QUESTION) {
        return <QuestionBookmark key={bookmark.id} bookmark={bookmark} />;
    } if (bookmark.bookmarkable && bookmark.bookmarkable_type === BOOKMARKABLE_TYPE.DOCUMENT) {
        return <DocumentBookmark key={bookmark.id} bookmark={bookmark} />;
    }

    if (typeof bookmark.bookmarkable === 'undefined') {
        return <LostAccessBookmark key={bookmark.id} bookmark={bookmark} />;
    }
    return <DeletedBookmark key={bookmark.id} bookmark={bookmark} />;
};

const SidebarBookmarkContainer = (props) => {
    const [bookmarks, setBookmarks] = useState();

    useEffect(() => {
        if (!window.userId || !window.loggedIn) return;
        $.get(getApiBookmarkUrl(window.userId))
            .then(({ bookmarks }) => setBookmarks(bookmarks));
    }, []);

    if (!bookmarks || !bookmarks.length) return null;

    return (
        <div className="left-nav__section px2">
            <div className="left-nav__header">Your bookmarks</div>
            {bookmarks.map(bookmark => <Bookmark key={bookmark.id} bookmark={bookmark} />)}
        </div>
    );
};

export default SidebarBookmarkContainer;
